/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedTitle_buyPage = {
    readonly totalResults: number | null;
    readonly meta: {
        readonly header: string | null;
    } | null;
    readonly " $refType": "BuySharedTitle_buyPage";
};
export type BuySharedTitle_buyPage$data = BuySharedTitle_buyPage;
export type BuySharedTitle_buyPage$key = {
    readonly " $data"?: BuySharedTitle_buyPage$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedTitle_buyPage">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedTitle_buyPage",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalResults",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "meta",
      "storageKey": null,
      "args": null,
      "concreteType": "MetaData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "header",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'ed8efab41813e3c73bd6326cf8b9397e';
export default node;
